import React from 'react';

interface LanguageSwitcherProps {
  currentLang: 'de' | 'en' | 'es';
  onLanguageChange: (lang: 'de' | 'en' | 'es') => void;
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ currentLang, onLanguageChange }) => {
  const languages = [
    { code: 'de' as const, label: 'DE' },
    { code: 'en' as const, label: 'EN' },
    { code: 'es' as const, label: 'ES' }
  ];

  return (
    <div className="flex items-center gap-1">
      {languages.map((lang, index) => (
        <React.Fragment key={lang.code}>
          <button
            onClick={() => onLanguageChange(lang.code)}
            className={`text-sm transition-colors ${
              currentLang === lang.code
                ? "text-accent font-medium"
                : "text-headline/60 hover:text-headline"
            }`}
            aria-label={`Switch to ${lang.label}`}
          >
            {lang.label}
          </button>
          {index < languages.length - 1 && (
            <span className="text-headline/30 text-sm">|</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};